"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesCompanyReturns$ = exports.CompaniesCompanyReturns$outboundSchema = exports.CompaniesCompanyReturns$inboundSchema = void 0;
exports.companiesCompanyReturnsToJSON = companiesCompanyReturnsToJSON;
exports.companiesCompanyReturnsFromJSON = companiesCompanyReturnsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
/** @internal */
exports.CompaniesCompanyReturns$inboundSchema = z.object({
    last_made_up_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    next_due_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "last_made_up_date": "lastMadeUpDate",
        "next_due_date": "nextDueDate",
    });
});
/** @internal */
exports.CompaniesCompanyReturns$outboundSchema = z.object({
    lastMadeUpDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    nextDueDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        lastMadeUpDate: "last_made_up_date",
        nextDueDate: "next_due_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompaniesCompanyReturns$;
(function (CompaniesCompanyReturns$) {
    /** @deprecated use `CompaniesCompanyReturns$inboundSchema` instead. */
    CompaniesCompanyReturns$.inboundSchema = exports.CompaniesCompanyReturns$inboundSchema;
    /** @deprecated use `CompaniesCompanyReturns$outboundSchema` instead. */
    CompaniesCompanyReturns$.outboundSchema = exports.CompaniesCompanyReturns$outboundSchema;
})(CompaniesCompanyReturns$ || (exports.CompaniesCompanyReturns$ = CompaniesCompanyReturns$ = {}));
function companiesCompanyReturnsToJSON(companiesCompanyReturns) {
    return JSON.stringify(exports.CompaniesCompanyReturns$outboundSchema.parse(companiesCompanyReturns));
}
function companiesCompanyReturnsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompaniesCompanyReturns$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompaniesCompanyReturns' from JSON`);
}
//# sourceMappingURL=companiescompanyreturns.js.map